





import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component
export default class Alerta extends Vue {
  @Prop() value!: string;
  show = false;
  @Watch("value")
  onChange() {
    if (this.value) this.mostraAlerta();
  }
  mostraAlerta() {
    this.show = true;
    setTimeout(this.fechaAlerta, 5000);
  }
  fechaAlerta() {
    this.show = false;
    this.$emit('input', "");
  }
}
